export const getNumeralViewItemsPaddings = (dataCount: number) => {
  return dataCount < 3 ? 1 : 0.5;
};
